export class MixerOverlayDeleteCmd {}
